/**
 * Authenticated fetch wrapper that centralizes the auth-provider transport concern.
 *
 * All admin/viewer API calls should use this instead of raw `fetch` with
 * `credentials: 'include'` so the auth transport strategy is owned in one place
 * rather than scattered across 13+ call sites.
 */
export function authenticatedFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  return fetch(input, {
    ...init,
    credentials: 'include',
  });
}
